import { render } from "./UserRoleModelDialog.vue?vue&type=template&id=1161c2ff&scoped=true"
import script from "./UserRoleModelDialog.vue?vue&type=script&lang=js"
export * from "./UserRoleModelDialog.vue?vue&type=script&lang=js"

import "./UserRoleModelDialog.vue?vue&type=style&index=0&id=1161c2ff&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1161c2ff"]])

export default __exports__